// Resolves a clean, human-friendly display name for a logged-in user.
// Prefers first_name, then a full_name token that isn't the email local part,
// finally falling back to a neutral label so we never show the raw email prefix.
export function resolveDisplayName(user) {
  if (!user) return 'My Account';

  const first = (user.first_name || '').trim();
  if (first) {
    return first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
  }

  const emailLocal = (user.email || '').split('@')[0].toLowerCase();
  const fullFirst = (user.full_name || '').trim().split(/\s+/)[0] || '';

  if (fullFirst && fullFirst.toLowerCase() !== emailLocal) {
    return fullFirst.charAt(0).toUpperCase() + fullFirst.slice(1).toLowerCase();
  }

  return 'My Account';
}

// Full display name (first + last, falling back to full_name) for forms that
// want the customer's whole name rather than the compact first-name label used
// in the navbar. Returns '' when the stored "name" is actually an email
// (some legacy/imported accounts) so it never surfaces as a prefilled
// "Your Name" value.
export function resolveFullName(user) {
  if (!user) return '';
  const first = (user.first_name || '').trim();
  const last = (user.last_name || '').trim();
  let name = [first, last].filter(Boolean).join(' ').trim();
  if (!name) name = (user.full_name || '').trim();
  if (!name || name.includes('@')) return '';
  return name;
}